<template>
  <div><slot></slot></div>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
// import { loadGLTF } from '../../Reusable/loadGLTF'
import { loadFBX } from '../../Reusable/loadFBX'
import { ShaderCube } from '../../Reusable/ShaderCube'
// import { MeshMatcapMaterial, DoubleSide, TextureLoader } from 'three'

export default {
  mixins: [O3DG2],
  data () {
    return {
      layouts: {}
    }
  },
  created () {
    // let texLoader = new TextureLoader(LoadingManager)
    // this.brown = new MeshMatcapMaterial({ color: 0xffffff, side: DoubleSide, matcap: texLoader.load(require('./matcap/brown.png')) })
    // this.yellow = new MeshMatcapMaterial({ color: 0xffd743, side: DoubleSide, matcap: texLoader.load(require('./matcap/bright-yellow.png')) })
    // this.pink = new MeshMatcapMaterial({ color: 0xffffff, side: DoubleSide, matcap: texLoader.load(require('./matcap/pink.jpg')) })
    // this.floor = new MeshMatcapMaterial({ color: 0xffffff, side: DoubleSide, matcap: texLoader.load(require('./matcap/silver.png')) })
    // this.celing = new MeshMatcapMaterial({ color: 0xffffff, side: DoubleSide, matcap: texLoader.load(require('./matcap/bright-yellow.png')) })
  },
  methods: {
    setup () {
      let objectURL = require('file-loader!./fbx/holy-cross.fbx')
      let shaderCube = new ShaderCube({ renderer: this.ctx.renderer, loop: this.onLoop, res: 32, resX: 32 })
      loadFBX(objectURL).then((stuff) => {
        stuff.traverse((item) => {
          if (item.isMesh) {
            item.material = shaderCube.out.material
          }
        })
        stuff.rotateX(Math.PI * 0.5)
        stuff.rotateY(Math.PI * -0.133333)
        stuff.scale.set(0.09, 0.09, 0.09)
        stuff.position.y += 30
        this.o3d.add(stuff)
      })
    }
  },
  mounted () {
    this.setup()
  }
}
</script>

<style>

</style>